export const getInfoWithPassportTypes = {
  SALER: 'saler',
  CUSTOMER: 'customer',
}
